import React, { useState } from "react";

const ItineraryDetails = ({ dayInfo, resourceKeys }) => {
  const [expandedIndices, setExpandedIndices] = useState([]);

  const toggleContent = (dayNo) => {
    setExpandedIndices((prev) =>
      prev.includes(dayNo)
        ? prev.filter((i) => i !== dayNo)
        : [...prev, dayNo]
    );
  };

  const stripHtml = (html = "") => html.replace(/<[^>]*>/g, "").trim();

  const renderDescription = (description, isExpanded, dayNo) => {
    if (!description) return null;

    const plainText = stripHtml(description);
    const words = plainText.split(/\s+/).filter(Boolean);
    const shortenedContent = words.slice(0, 20).join(" ");
    const showFull = isExpanded || words.length <= 20;
    const buttonText = isExpanded ? resourceKeys?.read_less : resourceKeys?.read_more;

    return (
      <>
        {showFull ? (
          <div dangerouslySetInnerHTML={{ __html: description }} />
        ) : (
          <p>{shortenedContent}</p>
        )}
        {words.length > 20 && (
          <a
            href="#"
            className="readmore"
            onClick={(e) => {
              e.preventDefault();
              toggleContent(dayNo);
            }}
          >
            {buttonText}
          </a>
        )}
      </>
    );
  };

  const isExpanded = expandedIndices.includes(dayInfo?.DayNo);

  return (
    <div className="box_wrap SPdetWrap common_bdrBtm w-100 p-4">
      <h4 className="SPdethead">{resourceKeys.your_itenary}</h4>
      <div className="itenary-item">
        <div className="itenary-head d-flex flex-wrap align-items-center">
          <div className="itenary-day-label">{resourceKeys.Day || 'Day'} {dayInfo?.DayNo}</div>
          <h3>{dayInfo?.Title || "Untitled Day"}</h3>
        </div>
        <div className="itenary-content">
          {renderDescription(dayInfo?.Description, isExpanded, dayInfo?.DayNo)}
        </div>
      </div>
    </div>
  );
};

export default ItineraryDetails;
